import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {setSeconds, format} from 'date-fns';
import {AsyncState, RejectedState} from '../../models/async_state';
import {Status} from '../../enums/status';
import {NewsQuery} from '../../gql/pwa/graphql';
import {News} from '../../network/news.ts';

interface State extends NewsQuery {}
const publishDate = new Date();
export const fetchNews = createAsyncThunk('news/fetchNews', async (data: {page: number; limit: number}) => {
    const result = await News.getNews(data.page, data.limit, formattedPublishDate());
    return result.data;
});
export const fetchMoreNews = createAsyncThunk('news/fetchMoreNews', async (data: {page: number; limit: number}) => {
    const result = await News.getNews(data.page, data.limit, formattedPublishDate());
    return result.data;
});

function mergedNews(oldNews?: NewsQuery['news'], newNews?: NewsQuery['news']): NewsQuery['news'] {
    const newsMap = new Map(oldNews?.map((news) => [news?.id, news]));
    if (newNews) {
        for (const news of newNews) {
            if (news) {
                newsMap.set(news.id, news);
            }
        }
    }
    return Array.from(newsMap.values());
}

function formattedPublishDate() {
    const date = setSeconds(publishDate, 0);
    return format(date, 'yyyy-MM-dd HH:mm:ss');
}

export const newsSlice = createSlice({
    name: 'news',
    initialState: () => {
        const initialState: AsyncState<State> = {
            status: Status.IDLE,
        };
        return initialState as AsyncState<State>;
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchNews.pending, (state) => {
            state.status = Status.PENDING;
        });
        builder.addCase(fetchNews.fulfilled, (state, action) => {
            state.status = Status.FULFILLED;
            state.news = action.payload.news;
            state.newsPageInfo = action.payload.newsPageInfo;
            state.__typename = action.payload.__typename;
        });
        builder.addCase(fetchNews.rejected, (state, action) => {
            state.status = Status.REJECTED;
            (state as RejectedState<State>).error = action.error.message ?? 'Error';
        });
        builder.addCase(fetchMoreNews.pending, (state) => {
            state.status = Status.LOADING_MORE;
        });
        builder.addCase(fetchMoreNews.fulfilled, (state, action) => {
            state.status = Status.FULFILLED;
            state.news = mergedNews(state.news, action.payload.news);
            state.newsPageInfo = action.payload.newsPageInfo;
            state.__typename = action.payload.__typename;
        });
        builder.addCase(fetchMoreNews.rejected, (state, action) => {
            state.status = Status.REJECTED;
            (state as RejectedState<State>).error = action.error.message ?? 'Error';
        });
    },
});
